
/**
 * @nullable
 */
export type SendNotificationRequestContentData = {[key: string]: unknown} | null;
